export function getCurrentUrl() {
  if (typeof window === 'undefined') {
    // eslint-disable-next-line no-console
    console.warn("Window isn't defined, can't get current url");
    return '';
  }

  return window.location.href;
}
export function getCurrentURLParams() {
  if (typeof window === 'undefined') {
    // eslint-disable-next-line no-console
    console.warn("Window isn't defined, can't get current url params");
    return '';
  }

  return window.location.search;
}
//# sourceMappingURL=windowUtils.js.map